/**
 * Labstep
 *
 * @module models/entity-snapshot
 * @desc Typescript export class for EntitySnapshot
 */

import { Experiment } from 'labstep-web/models/experiment.model';
import { PartialEntity } from 'labstep-web/models/partial-entity.model';
import { Protocol } from 'labstep-web/models/protocol.model';
import { ProtocolTable } from 'labstep-web/models/protocol-table.model';

export class EntitySnapshot extends PartialEntity {
  static readonly entityName = 'entity_snapshot' as const;

  get entityName(): string {
    return EntitySnapshot.entityName;
  }

  public constructor(data: Partial<EntitySnapshot>) {
    super(data);
    Object.assign(this, data);
  }

  object_id!: number;

  object_class!: string;

  get objectClassToEntityName(): string {
    if (this.object_class === 'Protocol') {
      return Protocol.entityName;
    }
    if (this.object_class === 'Experiment') {
      return Experiment.entityName;
    }
    if (this.object_class === 'ProtocolTable') {
      return ProtocolTable.entityName;
    }
    return '';
  }

  static entityNameToObjectClass(entityName: string): string {
    if (entityName === Protocol.entityName) {
      return 'Protocol';
    }
    if (entityName === Experiment.entityName) {
      return 'Experiment';
    }
    if (entityName === ProtocolTable.entityName) {
      return 'ProtocolTable';
    }
    return '';
  }
}
